import React,{useState} from "react";
import { TextField, Button, Container } from "@mui/material";
import style from "../../../styles/mystyle.module.css";
import { useTranslation } from "next-i18next";
import { Grid } from "@mui/material";
import config from "../../../next.config.js";
import LoadingButton from "@mui/lab/LoadingButton";
import Stack from "@mui/material/Stack";
import {styled} from "@mui/system";
import axios from 'axios'
import {useRouter} from 'next/router'
import {Customebtn , CustomeForm} from '../StyledComponent/Login.style'
import AlertDialog from '../../components/Dialogs/AlertDialog'

function PhoneCode({callBackData,callBackToResetPassword}) {
  const [loading, setLoading] = React.useState(false);
  const router=useRouter()
  function handleClick() {
    setLoading(true);
  }

  const { t } = useTranslation("common");
  const [responseMessgae, setResponseMessage] = React.useState({ type: null, message: null, show: false })

  const [inputList, setInputList] = useState(
    {
    
        code: "",
        mobile:"",
 
      errorArray: [
     
        { code: false, message: "هذا الحقل إجباري" },
        { mobile: false, message: "هذا الحقل إجباري" },
      ]
    }
 );
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const list = {...inputList}
    list[name] = value;
    handleError(list, name);
    setInputList({...list});
  };
  const handleSubmit=(e)=>{
    e.preventDefault();


    let hasError=true
    if(callBackData.showMobile==true){
        hasError= handleError(inputList,"mobile")&&handleError(inputList,"code")
    }
    else{
        hasError= handleError(inputList,"code")
    }
    if(hasError){
      let objectData={otp: inputList.code}
if(callBackData.showMobile==true){
  objectData.username=inputList.mobile 
}else{
  objectData.username=callBackData.mobile 
}
    axios
      .post(
        `${config["basePath"]}/api/user/resetPassword`,
        { data: objectData },
        {
          headers: {
            "Content-Type": "application/json",
            "accept-language":router.locale
          }
        }
      )
      .then(response => {
    
        if(response.data.data.response==true){
          callBackToResetPassword({...response.data.data,showResetPassword:true,mobile:objectData.username})
        }
        else {
          responseMessgae["show"] = true
          responseMessgae["type"] = "error"
          responseMessgae["message"] = response.data.data.subErrors[0].message
          setResponseMessage({ ...responseMessgae })
        }

      }).catch(err=>(err))
    }else{
        handleError(inputList,"code")
        handleError(inputList,"mobile")
        setInputList({...inputList})
    }
  } 
  const handleError = (varInput, name) => {
    let formIsValid = true;
    if (name == "mobile") {
      if (varInput.mobile != "") {
        let exp = new RegExp(/^7[01738][0-9]{7}$/gm);
        let val = exp.test(varInput.mobile);
        if (!val) {
            varInput.errorArray[1].mobile = true;
            varInput.errorArray[1].message = "الرقم غير صحيح";
          formIsValid = false;
        } else {
            varInput.errorArray[1].mobile = false;
        }
      } else {
        varInput.errorArray[1].mobile = true;
        formIsValid = false;
      }
      return formIsValid;
    } 
    if (name == "code") {
        if (varInput.code != "") {
            varInput.errorArray[0].code = false;
        } else {
          varInput.errorArray[0].code = true;
          formIsValid = false;
        }
        return formIsValid;
      } 
    
  };
  return (
    <div className={style.SectionContainer}>
     <AlertDialog open={responseMessgae.show} text={responseMessgae.message}
                type={responseMessgae.type}
                btnOk={() => {
                responseMessgae["show"] = false, setResponseMessage({ ...responseMessgae })
                }}
              />
      <div className={style.allcard}>
        <div className={style.cardLogin}>
          <div className={style.card1}>
            <form onSubmit={handleSubmit}>
              <div className={style.card3}>
                <div className={style.HeaderLogin}> {t("ForgetPassWord")} </div>
                <p className={style.EnterEmail}>{t("EntertheCode")}</p>

                <br />

                <Grid container spacing={2} style={{ paddingBottom: '10px',margin:0,width:"100%"}}>
                {callBackData.showMobile?<Grid
                    className="griditem"
                    item
                    lg={12}
                    xl={12}
                    sm={12}
                    md={12}
                    xs={12}
                    sx={{ paddingBottom: "10px" }}
                  >
                    <CustomeForm
                      sx={{
                        "&.MuiOutlinedInput-root.Mui-disabled": {
                          "& > fieldset": { boder: "none" }
                        }
                      }}
                      className="textfield"
                      label={t("phoneNumber")}
                      id="mobile"
                      name="mobile"
                      size="medium"
                      onChange={handleInputChange}
                      error={inputList.errorArray[1].mobile}
                      helperText={
                        inputList.errorArray[1].mobile
                          ? inputList.errorArray[1].message
                          : null
                      }
                  
                    />
                  </Grid>:""}
                  <Grid
                    className="griditem"
                    item
                    lg={12}
                    xl={12}
                    sm={12}
                    md={12}
                    xs={12}
                    sx={{ paddingBottom: "10px" }}
                  >
                    <CustomeForm
                      sx={{
                        "&.MuiOutlinedInput-root.Mui-disabled": {
                          "& > fieldset": { boder: "none" }
                        }
                      }}
                      className="textfield"
                      label={t("PhoneCode")}
                      id="code"
                      name="code"
                      size="medium"
                      onChange={handleInputChange}
                      error={inputList.errorArray[0].code}
                      helperText={
                        inputList.errorArray[0].code
                          ? inputList.errorArray[0].message
                          : null
                      }
                    />
                  </Grid>

                  <Grid
                    className="griditem"
                    item
                    lg={12}
                    xl={12}
                    sm={12}
                    md={12}
                    xs={12}
                    style={{}}
                  >
                    <Stack direction="row" spacing={2}>
                          {" "}
                          <Customebtn
                            loadingPosition="start"
                            sx={{ color: "white" }}
                            variant="outlined"
                            type={"submit"}
                          >
                            {t("Send")}
                          </Customebtn>{" "}
           
                    </Stack>
                  </Grid>
                </Grid>
              </div>
            </form>
          </div>
          <div className={style.card1}>
            <img
              className={style.loginimg}
              src={`${config.basePath}/assest/code.svg`}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PhoneCode;
